import { render, staticRenderFns } from "./BigListItem.vue?vue&type=template&id=3a2866e7&"
import script from "./BigListItem.vue?vue&type=script&lang=js&"
export * from "./BigListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports